/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: nJ1Nn58LcfAm7wemZm71QH
// Component: B-opJNgMH-HF
import * as React from "react";
import {
  PlasmicDataSourceContextProvider as PlasmicDataSourceContextProvider__,
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import * as plasmicAuth from "@plasmicapp/react-web/lib/auth";
import { usePlasmicDataSourceContext } from "@plasmicapp/data-sources-context";
import Op1WebWindowManagerSurface from "../../OP1WebWindowManagerSurface"; // plasmic-import: vcRC7TdY5z6b/codeComponent
import Op1WebAppWindow from "../../OP1WebAppWindow"; // plasmic-import: LpaIXhnQuy3G/codeComponent
import Op1WebFrameWindow from "../../OP1WebFrameWindow"; // plasmic-import: 3G-AdtWfG7Gm/codeComponent
import Op1WebFrameWindowControl from "../../OP1WebFrameWindowControl"; // plasmic-import: EQLX5d3CNuxY/codeComponent
import Op1WebDock from "../../Op1WebDock"; // plasmic-import: WsKrqHiP5PVH/component
import Op1WebButtonAppWindow from "../../OP1WebButtonAppWindow"; // plasmic-import: BXxrqEh84nVD/codeComponent
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import "./plasmic.css"; // plasmic-import: nJ1Nn58LcfAm7wemZm71QH/projectcss
import sty from "./PlasmicCustomComponentTestPage.module.css"; // plasmic-import: B-opJNgMH-HF/css
import image5Fm6Tt16Vk2Tb from "./images/image5.svg"; // plasmic-import: Fm6tt16Vk2tb/picture
import logo256PxYwIRv7DkmG2 from "./images/logo256Px.svg"; // plasmic-import: ywI_Rv7DkmG2/picture
import userFocusUhzXeSlJfh4K from "./images/userFocus.svg"; // plasmic-import: uhzXeSlJfh4K/picture

const emptyProxy = new Proxy(() => "", {
  get(_, prop) {
    return prop === Symbol.toPrimitive ? () => "" : emptyProxy;
  }
});

function wrapQueriesWithLoadingProxy($q) {
  return new Proxy($q, {
    get(target, queryName) {
      const query = target[queryName];
      return !query || query.isLoading || !query.data ? emptyProxy : query;
    }
  });
}

export function generateDynamicMetadata($q, $ctx) {
  return {
    openGraph: {},
    twitter: {
      card: "summary"
    }
  };
}

createPlasmicElementProxy;

export const PlasmicCustomComponentTestPage__VariantProps = new Array();

export const PlasmicCustomComponentTestPage__ArgProps = new Array();

const $$ = {};

function PlasmicCustomComponentTestPage__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "appWindowButton3.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton3.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.isOpen",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.isFocused",
        type: "private",
        variableType: "boolean",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton3.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      },
      {
        path: "appWindowButton4.state",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const currentUser = useCurrentUser?.() || {};
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <React.Fragment>
      <div
        data-plasmic-name={"root"}
        data-plasmic-override={overrides.root}
        data-plasmic-root={true}
        data-plasmic-for-node={forNode}
        className={classNames(
          "all",
          "root_reset_nJ1Nn58LcfAm7wemZm71QH",
          "plasmic_default_styles",
          "plasmic_mixins",
          styleTokensClassNames,
          sty.root
        )}
      >
        <Op1WebWindowManagerSurface
          data-plasmic-name={"op1WebWindowManagerSurface"}
          data-plasmic-override={overrides.op1WebWindowManagerSurface}
          className={classNames(
            "__wab_instance",
            sty.op1WebWindowManagerSurface
          )}
        >
          <Op1WebAppWindow
            children={null}
            className={classNames("__wab_instance", sty.op1WebAppWindow__ncUi)}
            windowId={"notes"}
          />

          <Op1WebAppWindow
            className={classNames(
              "__wab_instance",
              sty.op1WebAppWindow___4Qqow
            )}
            icon={image5Fm6Tt16Vk2Tb}
            iconAlt={""}
            title={"sfdg"}
            windowId={"conversations"}
          >
            <div className={classNames("all", sty.freeBox__xRbLi)}>
              <h1
                className={classNames(
                  "all",
                  "h1",
                  "h1__nJ1Nn",
                  "__wab_text",
                  sty.h1__oed8N
                )}
              >
                {"Conversations"}
              </h1>
              <div className={classNames("all", "__wab_text", sty.text__stXjj)}>
                {"Mock conversations inside a floating demo window."}
              </div>
            </div>
          </Op1WebAppWindow>
          <Op1WebAppWindow
            className={classNames("__wab_instance", sty.op1WebAppWindow__fYlf)}
            icon={logo256PxYwIRv7DkmG2}
            windowId={"textTest"}
          >
            <div className={classNames("all", sty.freeBox__q7S4K)}>
              <h1
                className={classNames(
                  "all",
                  "h1",
                  "h1__nJ1Nn",
                  "__wab_text",
                  sty.h1__rn0Tv
                )}
              >
                {"Text-Triggered Window"}
              </h1>
              <div
                className={classNames("all", "__wab_text", sty.text___1HbwW)}
              >
                {
                  "A demo floating window opened by a plain text trigger, not the dock."
                }
              </div>
            </div>
          </Op1WebAppWindow>
          <Op1WebFrameWindow
            data-plasmic-name={"op1WebFrameWindowPilot"}
            data-plasmic-override={overrides.op1WebFrameWindowPilot}
            className={classNames("__wab_instance", sty.op1WebFrameWindowPilot)}
            header={
              <React.Fragment>
                <Op1WebFrameWindowControl
                  action={"close"}
                  className={classNames(
                    "__wab_instance",
                    sty.op1WebFrameWindowControlPilot__lvU2
                  )}
                />

                <Op1WebFrameWindowControl
                  action={"minimize"}
                  className={classNames(
                    "__wab_instance",
                    sty.op1WebFrameWindowControlPilot___6Tk7F
                  )}
                />
              </React.Fragment>
            }
            windowId={"framePilot"}
          />
        </Op1WebWindowManagerSurface>
        <Op1WebDock
          data-plasmic-name={"op1WebDock"}
          data-plasmic-override={overrides.op1WebDock}
          appsWindoesGoHere={
            <React.Fragment>
              <Op1WebButtonAppWindow
                data-plasmic-name={"appWindowButton3"}
                data-plasmic-override={overrides.appWindowButton3}
                className={classNames("__wab_instance", sty.appWindowButton3)}
                icon={userFocusUhzXeSlJfh4K}
                onFocusedChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "isFocused"
                  ]).apply(null, eventArgs);
                }}
                onOpenChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "isOpen"
                  ]).apply(null, eventArgs);
                }}
                onStateChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton3",
                    "state"
                  ]).apply(null, eventArgs);
                }}
                windowId={"conversations"}
              />

              <Op1WebButtonAppWindow
                data-plasmic-name={"appWindowButton4"}
                data-plasmic-override={overrides.appWindowButton4}
                className={classNames("__wab_instance", sty.appWindowButton4)}
                icon={logo256PxYwIRv7DkmG2}
                onFocusedChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "isFocused"
                  ]).apply(null, eventArgs);
                }}
                onOpenChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "isOpen"
                  ]).apply(null, eventArgs);
                }}
                onStateChange={async (...eventArgs) => {
                  generateStateOnChangeProp($state, [
                    "appWindowButton4",
                    "state"
                  ]).apply(null, eventArgs);
                }}
                windowId={"framePilot"}
              />
            </React.Fragment>
          }
          className={classNames("__wab_instance", sty.op1WebDock)}
        />
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "op1WebWindowManagerSurface",
    "op1WebFrameWindowPilot",
    "op1WebDock",
    "appWindowButton3",
    "appWindowButton4"
  ],

  op1WebWindowManagerSurface: [
    "op1WebWindowManagerSurface",
    "op1WebFrameWindowPilot"
  ],

  op1WebFrameWindowPilot: ["op1WebFrameWindowPilot"],
  op1WebDock: ["op1WebDock", "appWindowButton3", "appWindowButton4"],
  appWindowButton3: ["appWindowButton3"],
  appWindowButton4: ["appWindowButton4"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCustomComponentTestPage__ArgProps,
          internalVariantPropNames: PlasmicCustomComponentTestPage__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCustomComponentTestPage__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCustomComponentTestPage";
  } else {
    func.displayName = `PlasmicCustomComponentTestPage.${nodeName}`;
  }
  return func;
}

function withUsePlasmicAuth(WrappedComponent) {
  const WithUsePlasmicAuthComponent = props => {
    const dataSourceCtx = usePlasmicDataSourceContext() ?? {};
    const { isUserLoading, user, token } = plasmicAuth.usePlasmicAuth({
      appId: "nJ1Nn58LcfAm7wemZm71QH"
    });
    return (
      <PlasmicDataSourceContextProvider__
        value={{
          ...dataSourceCtx,
          isUserLoading,
          userAuthToken: token,
          user
        }}
      >
        <WrappedComponent {...props} />
      </PlasmicDataSourceContextProvider__>
    );
  };
  return WithUsePlasmicAuthComponent;
}

export const PlasmicCustomComponentTestPage = Object.assign(
  // Top-level PlasmicCustomComponentTestPage renders the root element
  withUsePlasmicAuth(makeNodeComponent("root")),
  {
    // Helper components rendering sub-elements
    op1WebWindowManagerSurface: makeNodeComponent("op1WebWindowManagerSurface"),
    op1WebFrameWindowPilot: makeNodeComponent("op1WebFrameWindowPilot"),
    op1WebDock: makeNodeComponent("op1WebDock"),
    appWindowButton3: makeNodeComponent("appWindowButton3"),
    appWindowButton4: makeNodeComponent("appWindowButton4"),
    // Metadata about props expected for PlasmicCustomComponentTestPage
    internalVariantProps: PlasmicCustomComponentTestPage__VariantProps,
    internalArgProps: PlasmicCustomComponentTestPage__ArgProps,
    pageMetadata: generateDynamicMetadata(wrapQueriesWithLoadingProxy({}), {
      pageRoute: "/custom-component-test-page",
      pagePath: "/custom-component-test-page",
      params: {},
      query: {}
    })
  }
);

export default PlasmicCustomComponentTestPage;
/* prettier-ignore-end */
